import BaoCaoDiemNenNepPage from "./BaoCaoDiemNenNepPage";

export default BaoCaoDiemNenNepPage